<template>
  <div class="login-page">
    <div class="login-form-container">
      <div class="fiflbox-logo" />
      <el-form
        class="login-form"
        :model="form"
        :rules="formValidateRules"
        label-position="top"
        label-width="100px"
        @validate="handleValidateChange"
      >
        <el-form-item
          label="이메일"
          prop="email"
        >
          <el-input
            v-model="form.email"
            data-test="input-email"
            placeholder="정확한 이메일을 입력해주세요"
            auto-complete="off"
            clearable
          />
        </el-form-item>
        <el-button
          class="default"
          :disabled="!isEmailValidated"
          data-test="button-submit"
          @click="handleClickLogin"
        >
          비밀번호 재설정 이메일 보내기
        </el-button>
      </el-form>
    </div>
  </div>
</template>

<script>
import { validateEmailOnLogin, validatePassword } from "@/utils/form-validate-rules";
import { fiflboxApi } from '@/utils/api';

export default {
	name: "PasswordEmailIdentify",
	data() {
		return {
			isEmailValidated: false,
			form: {
				email: "",
			},
			formValidateRules: {
				email: [{ validator: validateEmailOnLogin, trigger: "change" }],
			},
		};
	},
	async mounted() {},
	methods: {
		handleValidateChange($event, isValidated) {
			this.isEmailValidated = isValidated;
		},
    async handleUnknownError() {
      await this.$alert(
        "일시적인 오류가 발생했습니다. 피플박스 앱 관리자에게 문의해주시길 바랍니다.",
        "비밀번호 재설정 오류",
        {
          confirmButtonText: "확인"
        });

      window.open("https://intercom.help/fiflbox", "_blank");
    },
		async handleClickLogin() {
			if (this.isEmailValidated) {
				try {
          let { data } = await fiflboxApi.v2.postPasswordReset(this.form);

					await this.$alert(
						"입력하신 이메일 주소로 비밀번호 재설정 이메일이 전송됐습니다.",
						"비밀번호 재설정",
						{
							confirmButtonText: "확인",
							showClose: false,
							customClass: "fifl-message-box",
							confirmButtonClass: "gray",
						}
					);

					return this.$router.push("/").catch(()=>{});
				} catch (err) {
				  if(err.response.status === 500) {
				    return this.handleUnknownError()
          }

					return this.$alert(
					  "등록된 이메일 계정이 아닙니다.",
            "이메일 오류",
            {
              confirmButtonText: "확인"
            });
				}
			}
		},
	},
};
</script>

<style lang="scss">
.login-page {
	height: 100%;
}

.login-form-container {
	margin: 0 auto;
	box-sizing: border-box;
	padding-top: 15vh;
	width: 350px;

	.login-form {
		margin-top: 50px;
	}

	.login-other-links {
		margin-top: 20px;
		height: 33px;
		font-size: 15px;
		font-weight: normal;
		letter-spacing: -0.8px;
		text-align: center;
		color: #d3d3d3;

		a {
			line-height: 33px;
			display: inline-block;
			width: calc(50% - 10px);
			text-decoration: none;
			color: #7a7a7a;
			font-size: 13px;
			letter-spacing: -0.8px;

			&:hover {
				text-decoration: underline;
			}
		}
	}
}

@media screen and (max-width: 768px) {
	.login-form-container {
		width: 100%;
		padding: 70px 40px;
		margin: 0;
		.login-form {
			margin-top: 70px;
		}
	}
}
</style>
